<template>
  <div class="col-6" :class="{ 'pt-3': setPadding }">
    <label class="pb-1" :for="identifier"
    >{{ label }}<span class="required">*</span></label
    >
    <NumberInput
      :value="value"
      :dynamic-class="{
        'input--error': isSubmit && error,
      }"
      :input-id="identifier"
      @input="$emit('input', $event)"
      :is-decimal-allowed="true"
    />
    <div v-if="isSubmit && error" class="text-error">
      {{ error.message }}
    </div>
  </div>
</template>

<script>
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  name: "CommonInput",
  components: {NumberInput},
  props: {
    error: {
      type: Object,
      default: () => {
      },
    },
    value: {
      type: Number,
      default: () => null,
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => null,
    },
    setPadding: {
      type: Boolean,
      default: () => false,
    },
    identifier: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
</style>
